module.exports = __webpack_public_path__ + "static/media/fulfillment_swift.6300e181.png";